import { useMemo } from 'react';
import { useSessionStorage } from 'usehooks-ts';

import { DEFAULT_TRADE_TAB, MOBILE_TRADE_TAB_LS_KEY } from 'common/constants';
import { TradeTabsType } from 'common/types';

import { routes } from 'routes/routes.constants';

import useCustomer from '../useCustomer';

const useTradePageLink = () => {
  const { checkFeaturesAvailability } = useCustomer();
  const [lastTradeTab] = useSessionStorage<TradeTabsType>(MOBILE_TRADE_TAB_LS_KEY, DEFAULT_TRADE_TAB);

  const isFuturesAvailable = useMemo(() => checkFeaturesAvailability('derivatives'), [checkFeaturesAvailability]);
  const isStocksAvailable = useMemo(() => checkFeaturesAvailability('stock'), [checkFeaturesAvailability]);

  const tradeLink = useMemo(() => {
    if (lastTradeTab === 'futures' && isFuturesAvailable) return lastTradeTab;
    if (lastTradeTab === 'stocks' && isStocksAvailable) return lastTradeTab;
    return 'spot';
  }, [isFuturesAvailable, isStocksAvailable, lastTradeTab]);

  return routes.getTradePage(tradeLink);
};

export default useTradePageLink;
